export default __webpack_public_path__ + "static/media/exotic-grey.14aac644.svg";